import { ModulesMap, ModulesConfigMap } from '../modulesMaps'

export default {
	[ModulesConfigMap[ModulesMap.WORK_ORDERS].GET_WORK_ORDERS]: {
		url: '/company/:companyId/work_orders/',
	},

	[ModulesConfigMap[ModulesMap.WORK_ORDERS].GET_WORK_ORDER]: {
		url: '/company/:companyId/work_orders/:workOrderId/',
	},

	[ModulesConfigMap[ModulesMap.WORK_ORDERS].CREATE_WORK_ORDER]: {
		url: '/company/:companyId/work_orders/',
		requestOptions: {
			method: 'POST',
		},
	},

	[ModulesConfigMap[ModulesMap.WORK_ORDERS].CREATE_FIELD_WORK_ORDER]: {
		url: '/company/:companyId/work_orders/create_field_work_order/',
		requestOptions: {
			method: 'POST',
		},
	},

	[ModulesConfigMap[ModulesMap.WORK_ORDERS].PUT_WORK_ORDER]: {
		url: '/company/:companyId/work_orders/:workOrderId/',
		requestOptions: {
			method: 'PUT',
		},
	},

	[ModulesConfigMap[ModulesMap.WORK_ORDERS].PUT_CLOSE_FIELD_WORK_ORDER]: {
		url: '/company/:companyId/work_orders/:workOrderId/close_field_work_order/',
		requestOptions: {
			method: 'PUT',
		},
	},

	[ModulesConfigMap[ModulesMap.WORK_ORDERS].PUT_UPDATE_FIELD_WORK_ORDER]: {
		url: '/company/:companyId/work_orders/:workOrderId/update_field_work_order/',
		requestOptions: {
			method: 'PUT',
		},
	},

	[ModulesConfigMap[ModulesMap.WORK_ORDERS].PATCH_WORK_ORDER]: {
		url: '/company/:companyId/work_orders/:workOrderId/',
		requestOptions: {
			method: 'PATCH',
		},
	},

	[ModulesConfigMap[ModulesMap.WORK_ORDERS].PATCH_CLOSE_FIELD_WORK_ORDER]: {
		url: '/company/:companyId/work_orders/:workOrderId/close_field_work_order/',
		requestOptions: {
			method: 'PATCH',
		},
	},

	[ModulesConfigMap[ModulesMap.WORK_ORDERS].PATCH_UPDATE_FIELD_WORK_ORDER]: {
		url: '/company/:companyId/work_orders/:workOrderId/update_field_work_order/',
		requestOptions: {
			method: 'PATCH',
		},
	},

	[ModulesConfigMap[ModulesMap.WORK_ORDERS].DELETE_WORK_ORDER]: {
		url: '/company/:companyId/work_orders/:workOrderId/',
		requestOptions: {
			method: 'DELETE',
		},
	},

	[ModulesConfigMap[ModulesMap.WORK_ORDERS].GET_WORK_ORDER_PREVIEW]: {
		url: '/company/:companyId/work_orders/:workOrderId/preview/',
	},

	[ModulesConfigMap[ModulesMap.WORK_ORDERS].GET_WORK_ORDER_POPUP]: {
		url: '/company/:companyId/work_orders/:workOrderId/popup/',
	},

	[ModulesConfigMap[ModulesMap.WORK_ORDERS].PATCH_WORK_ORDER_RECALCULATE]: {
		url: '/company/:companyId/work_orders/:workOrderId/recalculate_work_order/',
		requestOptions: {
			method: 'PATCH',
		},
	},

	[ModulesConfigMap[ModulesMap.WORK_ORDERS].GET_WORK_ORDER_IS_CAN_BE_CLOSED]: {
		url: '/company/:companyId/work_orders/:workOrderId/is_can_be_closed/',
	},

	[ModulesConfigMap[ModulesMap.WORK_ORDERS].CREATE_LOGISTIC_WORK_ORDER]: {
		url: '/company/:companyId/work_orders/create_logistic_work_order/',
		requestOptions: {
			method: 'POST',
		},
	},

	[ModulesConfigMap[ModulesMap.WORK_ORDERS].PUT_CLOSE_LOGISTIC_WORK_ORDER]: {
		url: '/company/:companyId/work_orders/:workOrderId/close_logistic_work_order/',
		requestOptions: {
			method: 'PUT',
		},
	},

	[ModulesConfigMap[ModulesMap.WORK_ORDERS].PATCH_CLOSE_LOGISTIC_WORK_ORDER]: {
		url: '/company/:companyId/work_orders/:workOrderId/close_logistic_work_order/',
		requestOptions: {
			method: 'PATCH',
		},
	},

	[ModulesConfigMap[ModulesMap.WORK_ORDERS].PUT_UPDATE_LOGISTIC_WORK_ORDER]: {
		url: '/company/:companyId/work_orders/:workOrderId/update_logistic_work_order/',
		requestOptions: {
			method: 'PUT',
		},
	},

	[ModulesConfigMap[ModulesMap.WORK_ORDERS].PATCH_UPDATE_LOGISTIC_WORK_ORDER]: {
		url: '/company/:companyId/work_orders/:workOrderId/update_logistic_work_order/',
		requestOptions: {
			method: 'PATCH',
		},
	},

	[ModulesConfigMap[ModulesMap.WORK_ORDERS].CREATE_HAND_MADE_WORK_ORDER]: {
		url: '/company/:companyId/work_orders/create_hand_made_order/',
		requestOptions: {
			method: 'POST',
		},
	},

	[ModulesConfigMap[ModulesMap.WORK_ORDERS].PATCH_HAND_MADE_WORK_ORDER]: {
		url: '/company/:companyId/work_orders/:workOrderId/update_hand_made_order/',
		requestOptions: {
			method: 'PATCH',
		},
	},

	[ModulesConfigMap[ModulesMap.WORK_ORDERS].COPY_TO_ANOTHER_BRIGADE]: {
		url: '/company/:companyId/work_orders/copy_to_another_brigade/',
		requestOptions: {
			method: 'POST',
		},
	},

	[ModulesConfigMap[ModulesMap.WORK_ORDERS].COPY_TO_ANOTHER_PERIOD]: {
		url: '/company/:companyId/work_orders/copy_to_another_period/',
		requestOptions: {
			method: 'POST',
		},
	},

	[ModulesConfigMap[ModulesMap.WORK_ORDERS].COPY_TO_ANOTHER_PLAN_WORK]: {
		url: '/company/:companyId/work_orders/copy_to_another_plan_work/',
		requestOptions: {
			method: 'POST',
		},
	},

}
